import { observer } from "mobx-react"
import React from "react"
import "../../App.less"
import CheckMob_Black from "../../assets/CheckMob_Black.svg"
import IncomeNudgeIcon from "../../assets/IncomeNudgeIcon.svg"
import HomePhoto from "../../assets/HomePhoto.svg"
// import Annuity from "../../assets/IncAnnuity.svg"
import AppStore from "../../Configs/Store/index"
import "../../styles/Benefits/IncomePlan.less"
import CheckList from "../Common/CheckList"
import TextMultiStyle from "../Common/TextMultiStyle"
import JSON from "../../Configs/JSON/IncomePlan.json"
import Image from "../Common/Image"

const IncomePlan = observer(() => {
  // const JSON = window.headConfig
  return (
    <div className="IncomePlan_FlexBox">
      <div className="IncomePlan_Parent1">
        <Image defer={false} src={AppStore.device === 0 ? HomePhoto : HomePhoto} className={"IncomePlan_ListImage"} alt={""} />
      </div>
      <div className="IncomePlan_Parent2">
        {/* {AppStore.device === 1 && <Image className="topImg" src={`assets/${JSON.Background.topimg}.png`} alt={""} />} */}
        <div className="IncomePlan_Card">
          <h1 className="IncomePlan_CardText">{JSON.Background.Title}</h1>
        </div>
        <div className="mobileOnly">
        <div className="IncomePlan_BigText">Ensure guaranteed<sup>~</sup> lifelong<br/>income in these uncertain times</div>

        </div>
        <div className="desktopOnly">

        <div className="IncomePlan_BigText">Ensure guaranteed<sup>~</sup> lifelong</div>
        <div className="IncomePlan_BigText">income in these uncertain times</div>
        </div>
        
        {/* <TextMultiStyle StyleText="IncomePlan_BigText" text={JSON.Background.subTitle} /> */}
        {/* {FormStore.quote_formTab == 1 && (
          <div className="AnnuityRoot">
            <img src={Annuity} alt="AnnuityMob" width={"23px"} height={"23px"} />
            <p>Increased Annuity Rates upto 12.3%</p>
          </div>
        )} */}
        <div className="IncomePlan_Nudge" style={{ display: "flex", alignItems: "center" }}>
            <Image defer={false} className={"IncomePlan_Nudge_Image"} src={IncomeNudgeIcon} alt={""} />
            <div className={"IncomePlan_Nudge_Text"}>
              Lock-in annuity rates up to 13.23%<sup style={{fontWeight: '300'}}>€</sup>
            </div>
        </div>
        <CheckList data={JSON["IncomePlan"]} imgSrc={CheckMob_Black} textClassName={"IncomePlan_ListText"} />
      </div>
    </div>
  )
})

export default IncomePlan
